(() => {
  const STICKY_CLASS = 'is-sticky';
  const STATIC_CLASS = 'rb-config-static';

  const observeSticky = stickyForm => {
    if (stickyForm.dataset.stickyObserved) return;
    stickyForm.dataset.stickyObserved = '1';

    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'height:1px;margin-bottom:-1px;pointer-events:none;';
    stickyForm.before(sentinel);

    new IntersectionObserver(
      ([entry]) => {
        stickyForm.classList.toggle(STICKY_CLASS, entry.boundingClientRect.top < 0);
      },
      { threshold: [0] }
    ).observe(sentinel);
  };

  // Ab 1280px legt das Theme .rb-configuration als horizontale Reihe aus
  // (siehe as-pm-0176-recharge.css). Die Aufteilung darf also nur darunter
  // greifen, sonst stapeln sich Lieferung und Filter auf dem Desktop.
  const SPLIT_QUERY = window.matchMedia('(max-width: 1279.98px)');

  const getBox = (cfg, stickyForm) => {
    let box = document.querySelector('.' + STATIC_CLASS);
    if (box) return box;

    box = document.createElement('div');
    box.className = STATIC_CLASS;
    stickyForm.before(box);

    // .rb-configuration startet mit hidden, recharge-filters.js entfernt es
    // erst nach dem Laden. Ohne Spiegelung flackert die neue Box kurz auf.
    if (cfg.hasAttribute('hidden')) {
      box.setAttribute('hidden', '');
      new MutationObserver(() => {
        box.toggleAttribute('hidden', cfg.hasAttribute('hidden'));
      }).observe(cfg, { attributes: true, attributeFilter: ['hidden'] });
    }

    return box;
  };

  // rb-delivery und rb-filters aus der Sticky-Box holen, damit nur rb-amount
  // oben haengen bleibt.
  const splitParts = (cfg, stickyForm) => {
    const box = getBox(cfg, stickyForm);
    ['rb-delivery', 'rb-filters'].forEach(selector => {
      const el = cfg.querySelector(':scope > ' + selector);
      if (el) box.appendChild(el);
    });
  };

  // Desktop: Originalreihenfolge rb-filters, rb-delivery, rb-amount
  const mergeParts = cfg => {
    const box = document.querySelector('.' + STATIC_CLASS);
    if (!box) return;
    const amount = cfg.querySelector(':scope > rb-amount');
    ['rb-filters', 'rb-delivery'].forEach(selector => {
      const el = box.querySelector(':scope > ' + selector);
      if (!el) return;
      if (amount) cfg.insertBefore(el, amount);
      else cfg.appendChild(el);
    });
  };

  const applyLayout = (cfg, stickyForm) => {
    if (SPLIT_QUERY.matches) splitParts(cfg, stickyForm);
    else mergeParts(cfg);
  };

  const setup = () => {
    const cfg = document.querySelector('.rb-configuration');
    const stickyForm = document.querySelector('.rb-sticky-form');
    const sticky = stickyForm && stickyForm.querySelector(':scope > .rb-container');
    if (!cfg || !stickyForm || !sticky) return false;
    if (cfg.parentElement !== sticky) sticky.appendChild(cfg);
    applyLayout(cfg, stickyForm);
    if (!stickyForm.dataset.layoutBound) {
      stickyForm.dataset.layoutBound = '1';
      SPLIT_QUERY.addEventListener('change', () => applyLayout(cfg, stickyForm));
    }
    observeSticky(stickyForm);
    return true;
  };

  if (setup()) return;

  const obs = new MutationObserver(() => {
    if (setup()) obs.disconnect();
  });
  obs.observe(document.body, { childList: true, subtree: true });
})();
